
const TokenKey = 'Admin-Token'

export function getToken() {
  return localStorage.getItem(TokenKey)
}

export function setToken(token) {
  return localStorage.setItem(TokenKey, token)
}

export function removeToken() {
  return localStorage.removeItem(TokenKey)
}

export function setOpenId(openId) {
  return localStorage.setItem("openId", openId)
}
export function getOpenId() {
  return localStorage.getItem("openId")
}